import React, { useRef, useState } from 'react'
import useOnClickOutside from 'utilities/hooks/useOutsideClick'
import ThreeDotsIcon from 'assets/images/rectangle/three-dots.svg'
interface DropDownProps {
    listWrapperClassName: string
    children: React.ReactNode
}
const CustomDropDown = ({ listWrapperClassName, children }: DropDownProps) => {
    const wrapperRef = useRef(null)
    const [isOpen, setisOpen] = useState<boolean>(false)

    useOnClickOutside(wrapperRef, () => setisOpen(false))
    return (
        <div className={`relative`} ref={wrapperRef}>
            <img
                src={ThreeDotsIcon}
                alt="three-dots"
                onClick={() => setisOpen(true)}
            />
            {isOpen && (
                <div
                    className={`${listWrapperClassName} left-4  rounded-[8px] bg-white shadow-[4px_4px_25px__rgba(0,0,0,0.1)] p-2 z-50`}
                >
                    {children}
                </div>
            )}
        </div>
    )
}

export default CustomDropDown
